import { useCallback, useEffect } from 'react'
import { KeyType, isKeyType } from '@cbgms/base/utils/keyevent'

/**
 * useOnEnterHandler allows you to attach 'enter' keyboard events to your own handlers
 * @param active whether the handler is active, you may pass 'false' to stop triggering your handler on 'enter'
 * @param handler the function to run when 'enter' key is pressed
 *
 * usage: useOnEnterHandler(isActive, ()=>{console.log('your handler to trigger on enter')})
 */
export const useOnEnterHandler = (active: boolean | undefined, handler: (e: KeyboardEvent) => void) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!e.defaultPrevented) {
        // only handle this event if it wasn't handled downstream. (we don't want to interfere with autocomplete)
        if (active && isKeyType(e, KeyType.EnterKey)) {
          e.preventDefault() // prevent form submissions
          handler(e)
        }
      }
    },
    [handler, active]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
